import * as React from "react";
import * as ReactDOM from "react-dom";

export interface IVoiceOverProps
{
    vo: string;
    style_name: string;
    onClick: () => void;
    children: React.ReactNode;
}

export class VoiceOver extends React.Component<IVoiceOverProps, null>
{
    constructor(public props: IVoiceOverProps)
    {
        super(props);
    }


    onMouseEnter = () =>
    {
        console.log('playing VO', this.props.vo);
    };


    /**
     * render the component
     * @returns {JSX.Element}
     */
    render() : JSX.Element
    {
        const {style_name, onClick} = this.props;

        return <span
                    className={style_name}
                    onMouseEnter={this.onMouseEnter}
                    onClick={onClick}>

                {this.props.children}

            </span>
    }
}


// WEBPACK FOOTER //
// ./src/ts/app/common/VoiceOver.tsx